import * as yup from "yup";

export const serieValidationSchema = yup.object().shape({
  serieContado: yup
    .string()
    .min(1, "Debe tener al menos 1 carácter")
    .max(15, "No debe exceder 15 caracteres")
    .required("Ingrese la serie contado"),

  serieCredito: yup
    .string()
    .min(1, "Debe tener al menos 1 carácter")
    .max(15, "No debe exceder 15 caracteres")
    .required("Ingrese la serie crédito"),
});
